export default "__VITE_PUBLIC_ASSET__97acf4e7__"